import * as React from "react";

import './CurrentSetScore.scss';
import { TickerMatchState } from '../../../models';
import { BeachTickerMatchState } from "../../../../../shared/beach/ticker";

interface Props {
  matchState: TickerMatchState | BeachTickerMatchState
  showGoldenSetIcon: boolean
}

export const CurrentSetScore = React.memo((props: Props) => {
  const { matchState, showGoldenSetIcon } = props
  if (!matchState) {
    return <div className="CurrentSetScore inactive">0:0</div>
  }
  const currentSet = matchState.matchSets[matchState.matchSets.length -1]
  const showGoldenSetLabel = currentSet.isGoldenSet && showGoldenSetIcon
  return <div className={"CurrentSetScore" + ((matchState.finished ? " finished" : "") + (currentSet.isGoldenSet ? " golden-set" : "") + (showGoldenSetLabel ? " with-golden-set-label" : ""))}>
    {showGoldenSetLabel && <span className="golden-set-label">(GS)</span>}
    <span className="score-value">{currentSet.setScore.team1 + ":" + currentSet.setScore.team2}</span>
  </div>
})
